import { z } from 'zod'
import { textoObrigatorio } from './comum'

/**
 * Vendas (decisões 10.3 e 10.4).
 *
 * A tabela `vendas` existe desde a Fase 2 e já guardava o valor do ganho.
 * Aqui entram os itens: o que foi vendido, digitado na hora (não há catálogo
 * de produtos, ADR 0054), quantidade por item e desconto — com o valor do card
 * virando a soma.
 */

// ─────────────────────────── venda ───────────────────────────

/**
 * Item da venda: o que foi vendido, digitado. A descrição é obrigatória,
 * senão a venda fica com uma linha sem nome no relatório.
 */
export const itemVendaSchema = z.object({
  descricao: textoObrigatorio('descrição do item', 160),
  quantidade: z.number().min(0.001).max(999_999),
  precoUnitario: z.number().min(0).max(9_999_999),
})

export function somarItens(itens: { quantidade: number; precoUnitario: number }[]): number {
  return Number(
    itens.reduce((total, item) => total + item.quantidade * item.precoUnitario, 0).toFixed(2),
  )
}
